<div class="whatsapp-consent-container">
  <div class="consent-card">
    <div class="whatsapp-icon">
      <i class="fab fa-whatsapp"></i>
    </div>
    
    <h2>Stay Connected via WhatsApp</h2>
    <p>Get instant updates, exclusive offers, and important service alerts directly on WhatsApp.</p>
    
    <div class="consent-checkbox">
      <label>
        <input 
          type="checkbox" 
          [(ngModel)]="whatsappConsent" 
          (change)="onConsentChange($event)">
        <span class="checkmark"></span>
        I agree to receive updates, offers, and service alerts on WhatsApp.
      </label>
    </div>
    
    <div class="action-buttons">
      <button 
        class="btn-whatsapp" 
        [disabled]="!whatsappConsent"
        (click)="continue()">
        <i class="fab fa-whatsapp"></i>
        Connect on WhatsApp
      </button>
    </div>
    
    <button class="btn-skip" (click)="skip()">
      Skip for now
    </button>
  </div>
</div>